import sortBy from 'lodash.sortby';

class Event {
  constructor(data, {
    timeSlotGetter
  }) {
    const {
      start,
      startDate,
      end,
      endDate,
      top,
      height
    } = timeSlotGetter.getRange(data.startDate, data.endDate);
    this.start = start;
    this.end = end;
    this.startMs = +startDate;
    this.endMs = +endDate;
    this.top = top;
    this.height = height;
    this.data = data;
  }
  get _width() {
    if (this.rows) {
      const columns = this.rows.reduce((max, row) => Math.max(max, row.leaves.length + 1), 0) + 1;
      return 100 / columns;
    }
    const availableWidth = 100 - this.container._width;
    if (this.leaves) {
      return availableWidth / (this.leaves.length + 1);
    }
    return this.row._width;
  }
  get width() {
    const noOverlap = this._width;
    const overlap = Math.min(100, this._width * 1.7);
    if (this.rows) {
      return overlap;
    }
    if (this.leaves) {
      return this.leaves.length > 0 ? overlap : noOverlap;
    }
    const {
      leaves
    } = this.row;
    const index = leaves.indexOf(this);
    return index === leaves.length - 1 ? noOverlap : overlap;
  }
  get xOffset() {
    if (this.rows) return 0;
    if (this.leaves) return this.container._width;
    const {
      leaves,
      xOffset,
      _width
    } = this.row;
    const index = leaves.indexOf(this) + 1;
    return xOffset + index * _width;
  }
}
function onSameRow(a, b, minimumStartDifference) {
  return Math.abs(b.start - a.start) < minimumStartDifference || b.start > a.start && b.start < a.end;
}
function sortByRender(events) {
  const sortedByTime = sortBy(events, ['startMs', e => -e.endMs]);
  const sorted = [];
  while (sortedByTime.length > 0) {
    let event = sortedByTime.shift();
    sorted.push(event);
    for (let i = 0; i < sortedByTime.length; i++) {
      const test = sortedByTime[i];
      if (event.endMs > test.startMs) {
        // eslint-disable-next-line no-continue
        continue;
      }
      if (i > 0) {
        // eslint-disable-next-line prefer-destructuring
        event = sortedByTime.splice(i, 1)[0];
        sorted.push(event);
      }
      break;
    }
  }
  return sorted;
}
function getDisplayEvents({
  events,
  timeSlotGetter
}) {
  const minimumStartDifference = Math.ceil(timeSlotGetter.timeStep * timeSlotGetter.timeSlotCount / 2);
  const proxies = events.map(event => new Event(event, {
    timeSlotGetter
  }));
  const eventsInRenderOrder = sortByRender(proxies);
  const containerEvents = [];
  for (let i = 0; i < eventsInRenderOrder.length; i++) {
    const event = eventsInRenderOrder[i];
    const container = containerEvents.find(c => c.end > event.start || Math.abs(event.start - c.start) < minimumStartDifference);
    if (!container) {
      event.rows = [];
      containerEvents.push(event);
      // eslint-disable-next-line no-continue
      continue;
    }
    event.container = container;
    let row = null;
    for (let j = container.rows.length - 1; !row && j >= 0; j--) {
      if (onSameRow(container.rows[j], event, minimumStartDifference)) {
        row = container.rows[j];
      }
    }
    if (row) {
      row.leaves.push(event);
      event.row = row;
    } else {
      event.leaves = [];
      container.rows.push(event);
    }
  }
  return eventsInRenderOrder.map(event => ({
    event: event.data,
    style: {
      top: event.top,
      height: event.height,
      width: event.width,
      xOffset: event.xOffset
    }
  }));
}

export { getDisplayEvents };
